import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchServices } from "src/redux/slices/services";
import { pick } from "src/utils/localize";
import { servicesForActivity } from "src/utils/services";

// Услуги, прикреплённые к туру галочками в админке (гид, переводчик и т.д.).
// Список пустой — блок не показывается вовсе.
export default function IncludedServices({ activity }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const services = useSelector((state) => state.services.services.items);

  useEffect(() => {
    if (!services?.length) dispatch(fetchServices());
    // тянем один раз при открытии страницы тура
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const attached = servicesForActivity(services, activity);
  if (attached.length === 0) return null;

  return (
    <div className="mt-8 rounded-xl border border-kj-line bg-kj-card/60 p-4 sm:p-5">
      <h3 className="text-xs font-bold uppercase tracking-[0.12em] text-kj-sub">
        {t("actInfo.servicesTitle")}
      </h3>
      <ul className="mt-3 flex flex-col divide-y divide-kj-line">
        {attached.map((service) => (
          <li
            key={service._id}
            className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 py-2.5 first:pt-0 last:pb-0"
          >
            <span className="text-base font-semibold text-kj-ink">
              {pick(service.name, i18n.language)}
            </span>
            <span className="font-extrabold text-kj-gold">{service.price}</span>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-xs text-kj-sub leading-relaxed">
        {t("actInfo.servicesHint")}
      </p>
    </div>
  );
}
